

































































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { db } from "@/scripts/firebase";
import CreateNewJinroRoom from "@/components/JinroHome/CreateNewJinroRoom.vue";
import ListView from "@/components/JinroHome/ListView.vue";
import ListHomeGameHistorySummaries from "@/components/JinroHome/HomeGameHistorySummaries.vue";
import JinroRoomRankings from "@/components/JinroHome/JinroRoomRankings.vue";

@Component({
  components: {
    ListView,
    ListHomeGameHistorySummaries,
    JinroRoomRankings,
    CreateNewJinroRoom,
  },
})
export default class JinroHome extends Vue {
  refCollection = db.collection(`jinrorooms`);
  activeTab = 0;
  gameHistoriesLength = 0;
  jinroRoomsLength = 0;
  rankingsLength = 0;

  get hasUser(): boolean {
    return !!this.$store.state.firebaseUser;
  }

  @Watch("activeTab")
  onChange() {
    this.$store.commit("setJinroHomeActiveTab", this.activeTab);
  }

  created() {
    if (!this.$store.state.jinroHomeActiveTab) {
      return;
    }
    this.activeTab = this.$store.state.jinroHomeActiveTab;
  }

  handleCreated(id: string) {
    this.$router.push(`/j/${id}`);
  }

  get authLink(): string {
    const defaultPath = "/auth";
    return defaultPath + "?from=" + this.$route.path;
  }
}
